import { FC } from 'react';
import { Project } from '../../../utils/models';

import Conditional from '../../common/conditional';

import css from './style.module.scss';
import config from '../../../utils/config';

interface ProjectSummaryProps {
	project: Project;
}

const ProjectSummary: FC<ProjectSummaryProps> = ({ project }) => {
	return (
		<div className={css.summary}>
			<div className="bg-light p-3 border">
				<h4 className={css['summary-header']}>
					<i className="bi bi-info-square-fill"></i>
					Project Details
				</h4>

				<div className={css['summary-item']}>
					<div className={css['summary-item-header']}>
						<div className="d-flex justify-content-between">
							<div>
								<h3>Assigned to {project.supervisorName}</h3>
								<p>{project.location}</p>
							</div>

							<div>
								<img
									src={project.organisation.organisationLogo}
									alt={project.organisationName}
									className={css['client-logo']}
								/>
							</div>
						</div>
					</div>

					<div className={css['summary-item-body']}>
						<div className={css['summary-item-body-item']}>
							<div className={css['summary-item-body-item-left']}>
								Customer Name:
							</div>
							<div className={css['summary-item-body-item-right']}>
								{project.organisationName}
							</div>
						</div>
						<Conditional isVisible={config.enableContactPerson}>
							<div className={css['summary-item-body-item']}>
								<div className={css['summary-item-body-item-left']}>
									Customer Contact:
								</div>
								<div className={css['summary-item-body-item-right']}>
									{project.contactPersonName}
								</div>
							</div>
						</Conditional>
						<div className={css['summary-item-body-item']}>
							<div className={css['summary-item-body-item-left']}>Facility:</div>
							<div className={css['summary-item-body-item-right']}>
								{project.facilityName}
							</div>
						</div>
						<div className={css['summary-item-body-item']}>
							<div className={css['summary-item-body-item-left']}>
								Inspection Type
							</div>
							<div className={css['summary-item-body-item-right']}>
								{project.inspectionTypeName}
							</div>
						</div>
						<div className={css['summary-item-body-item']}>
							<div className={css['summary-item-body-item-left']}>
								Equipment Tag:
							</div>
							<div className={css['summary-item-body-item-right']}>
								{project.equipmentTag}
							</div>
						</div>
						<div className={css['summary-item-body-item']}>
							<div className={css['summary-item-body-item-left']}>Document:</div>
							<div className={css['summary-item-body-item-right']}>
								{project.documentNumber}
							</div>
						</div>
						<div className={css['summary-item-body-item']}>
							<div className={css['summary-item-body-item-left']}>
								Equipment Description:
							</div>
							<div className={css['summary-item-body-item-right']}>
								{project.equipmentDescription}
							</div>
						</div>
						<div className={css['summary-item-body-item']}>
							<div className={css['summary-item-body-item-left']}>Location:</div>
							<div className={css['summary-item-body-item-right']}>
								{project.location}
							</div>
						</div>
						<div className={css['summary-item-body-item']}>
							<div className={css['summary-item-body-item-left']}>Module:</div>
							<div className={css['summary-item-body-item-right']}>
								{project.module}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ProjectSummary;
